import { BoxTitles } from "@boxes/BoxTitles";
import { Button, Checkbox, Drawer } from "@components";
import { ForEach } from "@components/control-statements";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/filtered-audience.module.scss";

export const RFVProfileFilterForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [values, setValues] = useState(node?.data?.values || []);

  const getFreshNode = () => {
    return {
      ...node,
      data: {
        ...node?.data,
        values: values,
      },
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [values]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.RFVProfileFilter}
    >
      <p className={styles.label}>Selecione os perfis</p>
      <ForEach
        items={[
          { label: "Campeões", value: "CAMPEOES" },
          { label: "Abandonados", value: "ABANDONADOS" },
          { label: "Hibernando", value: "HIBERNANDO" },
          { label: "Desligando", value: "DESLIGANDO" },
          { label: "Em risco", value: "EM_RISCO" },
          { label: "Requer atenção", value: "REQUER_ATENCAO" },
          { label: "Promissores", value: "PROMISSORES" },
        ]}
        render={(item) => (
          <Checkbox
            label={item.label}
            className={"mb-10"}
            checked={values.includes(item.value)}
            onChange={() => {
              if (values.includes(item.value)) {
                setValues(values.filter((f) => item.value != f));
              } else {
                setValues([...values, item.value]);
              }
            }}
          />
        )}
      />

      <div className={styles.footer}>
        <Button
          design="primary"
          className="w-100"
          onClick={() => onSave(getFreshNode())}
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};
